module.exports = __webpack_public_path__ + "img/maciej-wozniak.fa71c631.png";